
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E5E5E5","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M-34-310h1440V889H-34z"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1zM3.11 12c0-2.072.714-3.979 1.907-5.492l12.475 12.475A8.843 8.843 0 0112 20.89c-4.902 0-8.89-3.988-8.89-8.89h0zm15.873 5.492L6.508 5.017A8.843 8.843 0 0112 3.11c4.902 0 8.89 3.988 8.89 8.89a8.843 8.843 0 01-1.907 5.492h0z","fill":"#042132","stroke":"#042132","stroke-width":".5"}})])
          )
        }
      }
    